module.exports = __webpack_public_path__ + "media/images/users/family-d86e3b3e06d27a1a9de154f5832f92d7.png";